const Translations = {
    en:{
        whatsyourname: 'What\'s your name?',
        admin: 'Support',
        welcomeMessage: 'Hi ###name###!\nHow can we help you?',
        offline: {
          message: 'At this time none of our operators can assist you. Please <a href="/contact.php">send us a message</a> and we will respond as soon as possible.'
        },
        error: {
          name: 'Please, enter your name above'
        },
        blocked: {
          title: 'Blocked',
          message: 'You are temporarily blocked from our support for abusing the service'
        }
    },
    sp:{
        whatsyourname: '¿Cuál es tu nombre?',
        admin: 'Administrador',
        welcomeMessage: '¡Hola ###name###!\nComo podemos ayudarte?',
        offline: {
          message: 'En este momento ninguno de nuestros operadores puede ayudarlo. <a href="/contact.php">Envíe una mensaje</a> y le responderemos lo antes posible.'
        },
        error: {
          name: 'Por favor ingrese su nombre arriba'
        },
        blocked: {
          title: 'Bloqueado',
          message: 'Está bloqueado temporalmente de nuestro soporte por abusar del servicio'
        }
    },
    pt:{
        whatsyourname: 'Qual seu nome?',
        admin: 'Administrador',
        welcomeMessage: 'Olá ###name###!\nComo podemos te ajudar?',
        offline: {
          message: 'Nesse momento nenhum de nossos operadores pode te atender. Por favor, <a href="/contact.php">envie uma mensagem</a> que responderemos assim que possível.'
        },
        error: {
          name: 'Por favor, insira seu nome acima'
        },
        blocked: {
          title: 'Bloqueado',
          message: 'Você está bloqueado temporariamente de nosso suporte por abusar do serviço'
        }
    }
}

const domain = window.location.host;
let lang, Locale;
if(domain.indexOf('invitasalir')>=0){
  lang = 'sp';
  Locale = Translations.sp;
}else if(domain.indexOf('convidasair')>=0){
  lang = 'pt';
  Locale = Translations.pt;
}else{
  lang = 'en';
  Locale = Translations.en;
}

export default Locale;

export function formatTime(timestamp){
    const date = new Date(timestamp);
    let day = date.getDate();
    day = ("0" + day).slice(-2);
    let month = date.getMonth()+1;
    month = ("0" + month).slice(-2);
    let year = date.getFullYear();
    let hours = date.getHours();
    hours = ("0" + hours).slice(-2);
    let minutes = date.getMinutes();
    minutes = ("0" + minutes).slice(-2);
    let ampm = '';

    if(lang === 'en'){
      if(hours === '12'){
        ampm = ' PM';
      }else if(hours === '00'){
        hours = '12';
        ampm = ' AM';
      }else if(hours>12){
        hours = ('0' + (hours-12)).slice(-2);
        ampm = ' PM';
      }else{
        ampm = ' AM';
      }
    }

    const time = (lang === 'en')?`${month}/${day}/${year} ${hours}:${minutes}${ampm}`:`${day}/${month}/${year} ${hours}:${minutes}${ampm}`;
    return time;
}